import { render, staticRenderFns } from "./StrateKeypoints.vue?vue&type=template&id=27851f85&scoped=true&"
import script from "./StrateKeypoints.vue?vue&type=script&lang=js&"
export * from "./StrateKeypoints.vue?vue&type=script&lang=js&"
import style0 from "./StrateKeypoints.vue?vue&type=style&index=0&id=27851f85&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27851f85",
  null
  
)

export default component.exports